import { WaybillIdView } from '../../../../models';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ListRange, LoadAllFacade, MeasurementUnitCodesEnum, SetInitialStateFacade } from '../../../../../common';
import {
  ShipmentWaybillGoodsItemsState,
  ShipmentWaybillGoodsItemsStateModel,
} from './shipment-waybill-goods-items.state';
import { Observable } from 'rxjs';
import { ListSearchCriteriaFacade } from '../../../list-search-criteria/list-search-criteria.facade';
import { take } from 'rxjs/operators';
import { ShipmentWaybillGoodsItemModel } from '../../models/shipment-waybill-goods-items.model';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';
import {
  ShipmentWaybillGoodsItemsInitialState,
  ShipmentWaybillGoodsItemsLoad,
} from './shipment-waybill-goods-items.actions';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillGoodsItemsFacade implements LoadAllFacade, SetInitialStateFacade {
  listDto$: Observable<ShipmentWaybillGoodsItemsStateModel> = this.store.select(
    ShipmentWaybillGoodsItemsState.getState,
  );
  items$: Observable<ShipmentWaybillGoodsItemModel[]> = this.store.select(ShipmentWaybillGoodsItemsState.getGoodsItems);
  dimensionsUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentWaybillGoodsItemsState.getDimensionsUnitCode,
  );
  weightUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentWaybillGoodsItemsState.getWeightUnitCode,
  );
  volumeUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentWaybillGoodsItemsState.getVolumeUnitCode,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillGoodsItemsState.getLoaded);

  constructor(
    private store: Store,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
  ) {}

  loadAll(listRange?: ListRange): void {
    this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$
      .pipe(take(1))
      .subscribe((waybillIdView: WaybillIdView) => {
        this.store.dispatch(new ShipmentWaybillGoodsItemsLoad({ ...listRange, waybillIdView }));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillGoodsItemsInitialState());
  }
}
